import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React from 'react'

function HypothecationDetails({ hypothecations, type = '',policyDetail=null }) {

    return (
        <TableContainer sx={{ mt: 2, width: type == 'qc' ? '100%' : '49.50%' }} >

            <Typography
                variant="subtitle1"
                sx={{
                    backgroundColor: "#0954ae",
                    color: "#fff",
                    fontWeight: "bold",
                    p: 0,
                    textAlign: 'center'
                }}
            >
                Hypothecation Details
            </Typography>

            {/* Table */}
            <Table size="small"
                style={
                    type === 'qc'
                        ? {
                            opacity:
                                (
                                    policyDetail?.parentqcData ||
                                    policyDetail?.insurancePolicy?.qcData
                                )?.hypothecation_details
                                    ?.status === 'approve'
                                    ? 0.5
                                    : 1,
                            pointerEvents:
                                (
                                    policyDetail?.parentqcData ||
                                    policyDetail?.insurancePolicy?.qcData
                                )?.hypothecation_details
                                    ?.status === 'approve'
                                    ? 'none'
                                    : 'auto',
                        }
                        : {}
                }
            >
                <TableHead>
                    <TableRow sx={{ backgroundColor: "#e5f0ee" }}>
                        <TableCell sx={{ fontWeight: "bold", paddingBottom: 0, paddingTop: 0, width: '50%' }}>Bank</TableCell>
                        <TableCell sx={{ fontWeight: "bold", paddingBottom: 0, paddingTop: 0, width: '50%' }}>Branch</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {hypothecations?.map((item, index) => (
                        <TableRow key={index}>
                            <TableCell>{item.bank}</TableCell>
                            <TableCell>{item.branch}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default HypothecationDetails